import React, { useState } from "react";
import { CiSearch } from "react-icons/ci";

const SelectCountry = ({ setScreen, setCountry, country }: any) => {
  const countriesList = [
    { id: 1, name: "Nigeria" },
    { id: 2, name: "Ghana" },
    { id: 3, name: "Mali" },
    { id: 4, name: "Togo" },
    { id: 5, name: "Niger" },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const filteredCountries = countriesList.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full font-manrope">
      <h4 className="text-black dark:text-white font-semibold font-sora text-[16px]">
        Select country of document
      </h4>

      <div className="mt-6 w-full border border-[#AEBCC6] dark:border-gray-600 px-4 py-3 gap-2 rounded-xl active:border-secondary_button flex justify-start items-center">
        <CiSearch className="text-[28px] text-gray-500 dark:text-gray-400" />
        <input
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-11/12 placeholder:text-gray-500 text-gray-500 dark:text-gray-400 bg-transparent outline-none text-[15px]"
          placeholder="Search"
        />
      </div>

      <div className="mt-6 rounded-xl border border-[#AEBCC6] dark:border-gray-600">
        {filteredCountries.length > 0 ? (
          filteredCountries.map((countri, index) => {
            const isFirst = index === 0;
            const isLast = index === filteredCountries.length - 1;
            const isSingle = filteredCountries.length === 1;

            return (
              <div
                key={countri.id}
                onClick={() => {
                  setCountry(countri.name);
                }}
                className={`w-full px-4  ${
                  country === countri?.name
                    ? "bg-[#DAF1DD]"
                    : "bg-transparent hover:bg-[#E8F3FC]"
                }  cursor-pointer flex py-4 justify-start items-center ${
                  isSingle
                    ? "rounded-xl"
                    : isFirst
                    ? "rounded-t-xl"
                    : isLast
                    ? "rounded-b-xl"
                    : ""
                }`}
              >
                <h4 className="text-gray-500 text-[16px]">{countri.name}</h4>
              </div>
            );
          })
        ) : (
          <div className="w-full px-4 py-4 text-gray-500 dark:text-gray-400 text-[16px]">
            No countries found.
          </div>
        )}
      </div>
      <button
        disabled={!country}
        onClick={() => {
          setScreen(2);
        }}
        className={
          !country
            ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
            : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
        }
      >
        Next
      </button>
    </div>
  );
};

export default SelectCountry;
